import React, { useState, useEffect } from 'react';
import * as utils from '../../services/utils';
import useGlobal from '../../store';
import ReactGA from 'react-ga';
import CurrencySymbol from '../General/CurrencySymbol';

const ItemRow = (props) => {

    const [stateResponse, shoppinglistActions] = useGlobal(
        state => state.response,
        actions => actions.shoppinglistActions
    );

    const updateShoppingItem = (data) => {
        shoppinglistActions.updateShoppingItem(data);
    }

    const [isBought, setIsBought] = useState(props.isBought);
    const [showAmountForm, setShowAmountForm] = useState(!props.isBought || props.amountSpent.toString() === "0");
    const [amountSpent, setAmountSpent] = useState(props.isBought ? props.amountSpent : props.itemPrice || 0);
    const [isSaving, setIsSaving] = useState(false);
   
    useEffect(() => {
        if(!stateResponse || stateResponse.type !== "shoppinglistupdate") {
            return;
        }
        setIsSaving(false);
        setShowAmountForm(!stateResponse.data.isBought || stateResponse.data.amountSpent.toString() === "0");
    }, [stateResponse]);


    const toggleBought = (e) => {
        console.log('BOUGHT', e.target.checked);
        setIsBought(e.target.checked);
        if(!e.target.checked) {
            setShowAmountForm(true);
            setAmountSpent(props.itemPrice || 0);
            updateShoppingItem({
                amountSpent: 0,
                isBought: e.target.checked,
                shoppingID: props.shoppingID,
                itemID: props.itemID
            });

        } else {
            updateShoppingItem({
                amountSpent: 0,
                isBought: e.target.checked,
                shoppingID: props.shoppingID,
                itemID: props.itemID
            });
        }
    }

    const saveAmountSpent = () => {
        console.log('AMOUNT SPENT', amountSpent);
        
        setIsSaving(true);
        updateShoppingItem({
            amountSpent: amountSpent,
            isBought: isBought,
            shoppingID: props.shoppingID,
            itemID: props.itemID
        });
    }

    const toggleShowAmountForm = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setShowAmountForm(true);
    }



    const getItemUrl = (item) => {
        if(item.affURL) {
            return item.affURL;
        }
        if(!item.itemURLs || item.itemURLs === "") {
            return "#";
        }
        if(item.itemURLs.indexOf('amazon.com') !== -1 
            || item.itemURLs.indexOf('amazon.co.uk') !== -1
            || item.itemURLs.indexOf('amazon.de') !== -1
            || item.itemURLs.indexOf('amazon.fr') !== -1
            || item.itemURLs.indexOf('amazon.es') !== -1) {
            return formatAmazonUrl(item.itemURLs);
        } else if(item.itemURLs.includes("target.com")) {
            var t = item.itemURLs.match(/.*A-(.*?)($|#|\?)/);
            if(t && t.length > 1) {
                return 'https://goto.target.com/c/1430766/520943/2092?prodsku=' + t[1] + '&u=' + encodeURIComponent(item.itemURLs) + '&intsrc=PUI1_4061';
            }
        } 
        return "http://go.redirectingat.com/?id=86675X1539295&xs=1&url="+encodeURI(item.itemURLs)+"&sref="+encodeURI(window.location.href);
    }
    const formatAmazonUrl = (linkUrl) => {
        linkUrl = decodeURIComponent(linkUrl);
        if(linkUrl.indexOf('christmasli0b-20') === -1) {
            var parts = linkUrl.split("?");
            if(parts.length > 1) {
                var params = JSON.parse('{"' + decodeURI(parts[1]).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');
                params.tag = "christmasli0b-20";
                var queryString = Object.keys(params)
                        .map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]) })
                        .join('&');
                linkUrl = parts[0] + "?" + queryString;
            } else {
                linkUrl += "?tag=christmasli0b-20"; 
            }
        }
        return linkUrl;
    }
    const openLink = (item) => {
        let itemUrl = getItemUrl(item);
        window.open(itemUrl, '_blank');

        //TRACK REFERRAL CLICK EVENT
        let domain = utils.getDomain(item.itemURLs);
        let evtVal = item.price ? parseInt(item.price, 10) : 1;
        ReactGA.event({
            category: 'Referral Click',
            action: 'Shoppinglist Item',
            label: domain,
            value: evtVal
        });
    }

    
    
    return (
    <div className="kt-portlet kt-widget kt-widget--general-3 m-0">
        <div className="kt-portlet__body kt-portlet__body--fit">
            <div className="kt-widget__top pt-2 pb-2 pl-2 pr-2 hover-cursor">
                <div onClick={() => openLink(props)} className="kt-media kt-media--lg ">
                    <img src={props.itemPic} className="bg-white p-2" alt="item" />
                </div>
                <div onClick={() => openLink(props)} className="kt-widget__wrapper text-ellipsis">
                    <div className="kt-widget__label">
                        
                        <span className="kt-widget__title ">
                            {isBought ? <del>{props.itemName}</del> : props.itemName} 
                        </span>
                    </div>
                    {isBought ?
                        <div className="mt-2">
                            <span className="badge badge-success mr-2" onClick={(e) => toggleShowAmountForm(e)}>Spent <CurrencySymbol></CurrencySymbol>{amountSpent}</span>
                        </div> :
                        <div className="mt-2">
                            <span className="badge badge-primary mr-2">BUY <i className="la la-external-link"></i></span>
                            <span className="badge badge-success mr-2"><CurrencySymbol></CurrencySymbol>{props.itemPrice}</span>
                        </div>
                    }
                </div>
                <div className="pl-4">
                    <div className="form-group">
                        <label className="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
                            <input type="checkbox" checked={isBought} onChange={(e) => toggleBought(e)} />
                            <span></span>
                        </label>
                    </div>      
                </div>
            </div>
            {isBought && showAmountForm ? <div className="kt-widget__top pt-2 pb-2 pl-2 pr-2">
                <div className="form-group row m-0">
                    <label className="col-5 col-form-label">Amount spent?</label>
                    <div className="col-7">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text"><CurrencySymbol></CurrencySymbol></span>
                            </div>
                            <input className="form-control text-right" value={amountSpent} type="text" onChange={(e) => setAmountSpent(e.target.value)} />
                            <div className="input-group-append">
                                <button className="btn btn-success" onClick={() => saveAmountSpent()} type="button">
                                    { isSaving ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> : "Save" }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> : <></>}
            
        </div>
    </div>

    );
}

export default ItemRow;